// Local "request sent" markers per environment, so a click disables the other actions at once and the
// panel names what is in flight until the API's own marker (action.inFlight) takes over.
import { defineStore } from 'pinia';
import type { LocalPending } from '../actions/guards';

export const usePendingActions = defineStore('pendingActions', {
  state: () => ({ byEnv: {} as Record<string, LocalPending & { actionId?: string }> }),
  actions: {
    begin(env: string, type: LocalPending['type']) {
      this.byEnv[env] = { type, since: Date.now() };
    },
    accepted(env: string, actionId?: string) {
      const p = this.byEnv[env];
      if (p) p.actionId = actionId;
    },
    clear(env: string) {
      delete this.byEnv[env];
    },
  },
});
